import getConfig from 'next/config';

import { IInsurance } from '../interfaces/organizations';
import client from '../utils/client';

interface IListParams {
  status?: string;
  locationRoute?: string;
  ids?: number;
}

export const getInsurancesList = async (params: IListParams): Promise<IInsurance[]> => {
  const url = `${getConfig().publicRuntimeConfig.proxyPath}/insurances/`;
  const { data } = await client.get<IInsurance[]>(url, { params });

  return data ?? [];
};
